import React from "react";
// import image1 from '../../../assets/images/fitbae/'
import { imageCodes } from "../../../template_codes/fitbae/home_page_codes";
import { SlideshowLightbox } from "lightbox.js-react";
import "lightbox.js-react/dist/index.css";
const Imagebanner = () => {
  console.log(imageCodes.img1.image);
  return (
    <section id="lookbook" className=" lg:px-10 px-4">
      <div className="text-center py-10">
        <h1 className="uppercase text-[22px]"> look book</h1>
      </div>
      <div
        className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-3 lg:gap-3 gap-1">
        {/* <div className="lg:h-[600px] h-[100px] w-full"> */}
        <img
          src={imageCodes.img1.image}
          className="lg:h-[600px] h-[100px] w-full object-cover"
          alt=""
        />
        {/* </div> */}
        {/* <div className="lg:h-[600px] h-[100px] w-full"> */}
        <img
          src={imageCodes.img2.image}
          className="lg:h-[600px] h-[100px] w-full object-cover"
          alt=""
        />
        {/* </div> */}
        {/* <div className="lg:h-[600px] h-[100px] w-full"> */}
        <img
          src={imageCodes.img3.image}
          className="lg:h-[600px] h-[100px] w-full object-cover"
          alt=""
        />
        {/* // </div> */}
        {/* <div className="lg:h-[600px] h-[100px] w-full"> */}
        <img
          src={imageCodes.img4.image}
          className="lg:h-[600px] h-[100px] w-full object-cover"
          alt=""
        />
        {/* // </div> */}
        {/* <div className="lg:h-[600px] h-[100px] w-full"> */}
        <img
          src={imageCodes.img5.image}
          className="lg:h-[600px] h-[100px] w-full object-cover"
          alt=""
        />
        {/* // </div> */}
        {/* <div className="lg:h-[600px] h-[100px] w-full"> */}
        <img
          src={imageCodes.img6.image}
          className="lg:h-[600px] h-[100px] w-full object-cover"
          alt=""
        />
        {/* // </div> */}
      </div>
    </section>
  );
};

export default Imagebanner;
